module.exports = __webpack_public_path__ + "static/media/performer.870aceae.png";